export function addTargetBlankToExtLinks(el) {
  const documentNodes = el.getElementsByTagName('a') || [];
  const anchors = Array.from(documentNodes);
  anchors.forEach(anchor => {
    if (anchor.hostname && anchor.hostname !== window.location.hostname) {
      anchor.setAttribute('target', '_blank');
    }
  });
}
